<script>
  import { createData } from "$utils/data.svelte.js";
  import { onMount } from "svelte";
  import { tool_title, instruction_text } from "$data/consts.js";
  import GrayBox from "./GrayBox.svelte";
  import Searchbar from "./Searchbar.svelte";
  import Chart from "./Chart.svelte";
  import { getAbsoluteUrl } from "$utils/urls.js";
  import { Block } from "@urbaninstitute/dataviz-components";
  import ComboBox from "./ComboBox.svelte";

  const toolData = createData();

  onMount(() => {
    toolData.fetchData();
  });

  let is_name_long = $derived(toolData.activeCommunityNameShort !== toolData.activeCommunityName);

  let headingEl;

  function scrollToTop() {
    headingEl?.scrollIntoView({ behavior: "smooth" });
  }
</script>

<div bind:this={headingEl} class="heading" style:background-image="url({getAbsoluteUrl('/city-layer.svg')})">
  <h2>{tool_title}</h2>
  <p class="instruction">{instruction_text}</p>
  <ComboBox
    type="single"
    items={toolData.communityDropdownData}
    bind:value={toolData.activeCommunityID}
    placeholder="Search"
    maxWidth={460}
  />
  <!-- <Searchbar
    placeholder="Search"
    data={toolData.communityDropdownData}
    bind:value={toolData.activeCommunityID}
  /> -->
</div>

<div class="sticky-where-am-i">
  <Block>
    <h3 class="bolder-title">{toolData.activeCommunityNameShort}</h3>
    {#if is_name_long}
      <p class="full-name">{toolData.activeCommunityName}</p>
    {/if}
  </Block>
</div>

{#if toolData.activeCommunityID}
  <!-- <Block>
    <GrayBox title="EDA Disaster Supplemental Grant Program">
      <div class="underlined box-one">
        <h3 class="highlighted {toolData.myCommunityData.eda_factor_eligibility}">
          {toolData.firstBoxTitle}
        </h3>
      </div>
      <p>{@html toolData.firstBoxText}</p>
    </GrayBox>
  </Block> -->

  <Block>
    <GrayBox>
      <Chart />
    </GrayBox>
  </Block>
  <!-- <Block>
    <GrayBox title="FEMA's Hazard Mitigation Grant Program">
      {#if toolData.alternateFundingSet.eligible.length > 0}
        <div class="underlined box-one">
          <h3 class="alt highlighted yes">Eligible</h3>
        </div>
        {#each toolData.alternateFundingSet.eligible as item}
          <div class="program">
            <p>{@html item.text}</p>
          </div>
        {/each}
      {/if}
      {#if toolData.alternateFundingSet.ineligible.length > 0}
        <div class="underlined box-one">
          <h3 class="alt highlighted no">Ineligible</h3>
        </div>
        {#each toolData.alternateFundingSet.ineligible as item}
          <div class="program">
            <p>{@html item.text}</p>
          </div>
        {/each}
      {/if}
    </GrayBox>
  </Block> -->
  <!-- <div class="return-to-top">
    <button onclick={scrollToTop}>RETURN TO TOP <svg class="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="22" height="22"><path fill="#000" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z"/></svg></button>
  </div> -->
{/if}

<style>
  .return-to-top {
    display: flex;
    justify-content: center;
    padding: 24px 0 40px;
    button {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-family: Lato, sans-serif;
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.08em;
      color: #000;
      text-transform: uppercase;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      .arrow {
        display: inline-block;
        vertical-align: middle;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 24px 76px;
    h2 {
      margin: 80px 0 10px 0;
      text-align: center;
      max-width: 980px;
    }
    p.instruction {
      color: var(--neutral-darkest, #353535);
      text-align: center;
      font-family: Lato;
      font-size: 20px;
      margin: 10px 0 40px;
      max-width: 670px;
    }
  }

  .sticky-where-am-i {
    position: sticky;
    top: 60px;
    z-index: 2;
    margin: 60px 0 0px;
    padding: var(--spacing-8) var(--spacing-2);
    background-color: white;
    h3.bolder-title {
      margin: 0;
      text-align: center;
      font-family: var(--font-family-sans-alt);
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 44px;
      text-transform: none;
    }
    p.full-name {
      text-align: center;
      padding: 0px 40px;
      margin-bottom: 0;
      margin-top: 8px;
      font-size: var(--font-size-small);
      line-height: 150%;
    }
  }

  .underlined {
    margin-bottom: -20px;
    /* margin-bottom: 18px; */
    border-bottom: 2px solid white;
    &.box-one {
      margin-bottom: 25px;
    }
  }
  .underlined > h3.highlighted {
    padding-left: 6px;
    line-height: 26px;
    margin-bottom: 18px;

    &.yes {
      border-left: 6px solid var(--color-green);
    }
    &.possibly {
      border-left: 6px solid var(--color-yellow-shade-dark);
    }
    &.no {
      border-left: 6px solid #c53030;
    }
    &.alt {
      margin-top: 60px;
    }
  }
  .program {
    margin-bottom: 27px;
    h6.program-title {
      margin-bottom: 10px;
      margin-top: 50px;
      font-family: var(--font-family-sans);
    }
  }
</style>
